import {
  call, put, takeEvery
} from "redux-saga/effects";
import {
  FETCH_REMINDERS_START,
  ADD_REMINDER_START,
  EDIT_REMINDER_START,
  DELETE_REMINDER_START,
} from "./actionTypes";
import {
  fetchRemindersSuccess,
  addReminderSuccess,
  editReminderSuccess,
  deleteReminderSuccess,
  remindersApiError,
} from "./actions";
import {
  getReminders,
  addReminder,
  editReminder,
  deleteReminder,
} from "apis/reminders";
import { showSuccessNotification, showErrorNotification } from "store/notifications/actions";

function* fetchRemindersSaga({ payload }) {
  try {
    const data = yield call(getReminders, { payload });
    yield put(fetchRemindersSuccess(data));
  } catch (error) {
    yield put(remindersApiError(error.message));
  }
}

function* addReminderSaga({ payload }) {
  try {
    const data = yield call(addReminder, payload);
    yield put(addReminderSuccess(data));
    yield put(showSuccessNotification("Reminder added successfully"));
  } catch (error) {
    yield put(remindersApiError(error.message));
    yield put(showErrorNotification(error.message || "Failed to add reminder"));
  }
}

function* editReminderSaga({ payload }) {
  try {
    const data = yield call(editReminder, payload);
    yield put(editReminderSuccess(data));
    yield put(showSuccessNotification("Reminder updated successfully"));
  } catch (error) {
    yield put(remindersApiError(error.message));
    yield put(showErrorNotification(error.message || "Failed to update reminder"));
  }
}

function* deleteReminderSaga({ payload }) {
  try {
    const data = yield call(deleteReminder, payload);
    yield put(deleteReminderSuccess(data));
    yield put(showSuccessNotification("Reminder deleted successfully"));
  } catch (error) {
    yield put(remindersApiError(error.message));
    yield put(showErrorNotification(error.message || "Failed to delete reminder"));
  }
}

function* remindersSaga() {
  yield takeEvery(FETCH_REMINDERS_START, fetchRemindersSaga);
  yield takeEvery(ADD_REMINDER_START, addReminderSaga);
  yield takeEvery(EDIT_REMINDER_START, editReminderSaga);
  yield takeEvery(DELETE_REMINDER_START, deleteReminderSaga);
}

export default remindersSaga;
